export default {
  auth: () => import("/opt/build/repo/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)
}